import { styled } from '@mui/material/styles';
import Select from '@mui/material/Select';
import { textColor } from '@style/variables';

export const AlternateSizeContainer = styled(Select)`
  max-width: 100%;
  width: calc(390px + 0.5rem);
  border-radius: 4px;
`;

interface ColorProps {
  color: string;
}

export const AlternateColorsContainer = styled('div')<ColorProps>`
  margin-bottom: 4rem;

  a {
    margin-right: 3rem;
    padding: 2rem 3rem 2rem 2rem;
    color: ${textColor};
  }

  .color-link {
    border: solid 2px ${textColor};
    border-radius: 20px;
  }

  .dot {
    height: 1rem;
    width: 1rem;
    background-color: ${(props) => props.color};
    border-radius: 50%;
    display: inline-block;
    position: relative;
    top: 2px;
    margin-right: 2rem;
  }
`;

export const AlternateColorDot = styled('span')<ColorProps>`
  height: 1rem;
  width: 1rem;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  display: inline-block;
  position: relative;
  top: 2px;
  margin-right: 2rem;
`;

export const ProductImagesContainer = styled('div')`
  .main-product-image {
    width: 90%;
  }
  .discount-flag {
    position: absolute;
    height: 40px;
    top: 20px;
    background-color: #d95e16;
    padding-left: 40px;
    padding-right: 40px;
    left: 26px;
    border-radius: 0 5px 5px 0;
    margin: auto;
  }
  .img-fluid-pdp {
    display: block;
    margin: auto;
  }
  .img-fluid-slider-thumbnail {
    display: block;
    margin: auto;
    height: 50px;
  }
  @media screen and (max-width: 767px) {
    .img-fluid-slider-thumbnail {
      height: 40px;
    }
    .discount-flag {
      top: 20px;
      left: 23px;
    }
  }
  @media screen and (min-width: 768px) and (max-width: 991px) {
    .discount-flag {
      left: 16px;
    }
  }
  @media screen and (min-width: 576px) and (max-width: 767px) {
    .discount-flag {
      left: 23px;
    }
  }
  @media screen and (min-width: 992px) and (max-width: 1199px) {
    .discount-flag {
      left: 21px;
    }
  }
  @media screen and (max-width: 576px) {
    .discount-flag {
      top: 14px;
      left: 17px;
    }
  }
`;

export const FeaturedCardContainer = styled('div')`
  .featured-link {
    border-bottom: 2px solid #25282a;
    cursor: pointer;
  }
  h5 {
    font-size: 1.625rem;
    line-height: 28px;
    margin-bottom: 0;
  }
`;

export const ProductFeaturesContainer = styled('div')`
  h5 {
    font-size: 1.625rem;
    line-height: 28px;
    margin-bottom: 0;
  }
`;

export const ProductRowContainer = styled('div')`
  a {
    color: white !important;
  }
`;

export const ProductListItemContainer = styled('div')`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h5 {
    font-size: 1.625rem;
    line-height: 28px;
    text-align: left;
    margin-top: 20px;
  }
  h6 {
    font-family: 'Roboto', sans-serif;
    text-transform: unset;
    font-size: 1.125rem;
    line-height: 28px;
    letter-spacing: 0.15px;
    font-weight: 200;
  }
  a {
    cursor: pointer;
    text-decoration: none;
  }
  .card {
    background: #f7f7f7;
    border: 0;
  }
  .discount-flag {
    position: absolute;
    background-color: #d95e16;
    top: 20px;
    left: 0px;
    border-radius: 0px 5px 5px 0px;
    margin: auto;
    z-index: 8;
  }
  .current-deal-h5 {
    font-size: 1.2rem;
    position: relative;
    top: 0%;
    transform: translate(0%, -50%);
  }
  .add-to-cart-button {
    width: 100%;
    align-self: flex-end;
  }
  .discount-flag {
    height: 38px;
    min-width: 220px;
  }
  @media only screen and (min-width: 770px) and (max-width: 992px) {
    .responsive-card-text {
      font-size: 24px;
    }
    .discount-flag {
      height: 30px;
      min-width: 170px;
    }
    .current-deal-h5 {
      font-size: 1rem;
      transform: translate(0%, -60%);
    }
  }
  @media only screen and (min-width: 577px) and (max-width: 769px) {
    .discount-flag {
      height: 50px;
      min-width: 320px;
    }
    .current-deal-h5 {
      font-size: 1.5rem;
      transform: translate(0%, -30%);
    }
  }
  @media only screen and (max-width: 576px) {
    .discount-flag {
      height: 45px;
      min-width: 280px;
    }
    .current-deal-h5 {
      font-size: 1.4rem;
      transform: translate(0%, -40%);
    }
  }
`;
